import { ArrowRight, CheckCircle2, Eye, List } from 'lucide-react';
import { Button } from '../../../ui/button';

interface WizardSuccessProps {
  spaceName: string;
  spaceSlug: string;
  isPublic: boolean;
  onGoBack: () => void;
}

export function WizardSuccess({ spaceName, isPublic, onGoBack }: WizardSuccessProps) {
  // Le client est sur le port 5173, l'admin sur 5174
  const clientBaseUrl = import.meta.env.VITE_CLIENT_URL;
  const publicUrl = `${clientBaseUrl}/accueil`;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '600px',
        background: 'white',
        borderRadius: '24px',
        padding: '4rem 2rem',
        textAlign: 'center',
        boxShadow: '0 10px 40px rgba(0,48,60,0.06)',
        border: '1px solid #f0f0f0',
        animation: 'fadeIn 0.6s ease-out',
      }}
    >
      <div
        style={{
          width: '90px',
          height: '90px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #00758d 0%, #00303c 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '2rem',
          boxShadow: '0 10px 20px rgba(0,117,141,0.2)',
          animation: 'scaleIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
        }}
      >
        <CheckCircle2 size={48} color="white" />
      </div>

      <h1
        style={{
          fontSize: '2.5rem',
          fontWeight: 800,
          color: '#00303c',
          marginBottom: '1rem',
          letterSpacing: '-0.02em',
        }}
      >
        Configuration Terminée !
      </h1>

      <p
        style={{
          fontSize: '1.1rem',
          color: '#64748b',
          maxWidth: '500px',
          lineHeight: '1.6',
          marginBottom: '3rem',
        }}
      >
        L'espace <strong>{spaceName}</strong> a été configuré avec succès.
        {isPublic
          ? ' Il est maintenant visible et prêt à être réservé par vos clients.'
          : ' Vous pourrez le publier à tout moment depuis la liste des espaces.'}
      </p>

      <div
        style={{
          display: 'flex',
          gap: '1.5rem',
          justifyContent: 'center',
          flexWrap: 'wrap',
        }}
      >
        <Button
          onClick={onGoBack}
          variant="outline"
          style={{
            height: '56px',
            padding: '0 2rem',
            borderRadius: '16px',
            fontSize: '1rem',
            fontWeight: 600,
            gap: '0.75rem',
            border: '2px solid #e2e8f0',
          }}
        >
          <List size={20} />
          Retour à la liste
        </Button>

        <Button
          onClick={() => window.open(publicUrl, '_blank')}
          style={{
            height: '56px',
            padding: '0 2rem',
            borderRadius: '16px',
            background: '#00758d',
            color: 'white',
            fontSize: '1rem',
            fontWeight: 600,
            gap: '0.75rem',
            boxShadow: '0 4px 14px rgba(0,117,141,0.25)',
          }}
        >
          <Eye size={20} />
          Voir l'espace public
          <ArrowRight size={18} />
        </Button>
      </div>

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes scaleIn {
            from { transform: scale(0.5); opacity: 0; }
            to { transform: scale(1); opacity: 1; }
          }
        `}
      </style>
    </div>
  );
}
